import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "NewTag"
});
const _hoisted_1 = {
  width: "32",
  height: "16",
  viewBox: "0 0 32 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.14258 7.83364C1.14258 4.18681 3.88775 1.23047 7.2741 1.23047L24.5711 1.23047C28.0427 1.23047 30.8569 4.26116 30.8569 7.9997C30.8569 11.7382 28.0427 14.7689 24.5711 14.7689H1.14258V7.83364Z",
  fill: "#E64C4C"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.14286 0H24.5714C28.6741 0 32 3.58172 32 8C32 12.4183 28.6741 16 24.5714 16H0V9.84615C0 8.22774 0.362581 6.70052 1.00504 5.35357L1.16456 5.03381C1.9886 3.45277 3.20614 2.14157 4.67425 1.25414L4.97117 1.08235C6.22191 0.390472 7.64004 0 9.14286 0ZM30.8571 8C30.8571 4.26146 28.0429 1.23077 24.5714 1.23077H9.14286C4.72458 1.23077 1.14286 5.08801 1.14286 9.84615V14.7692H24.5714C28.0429 14.7692 30.8571 11.7385 30.8571 8Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5447 11.0767V6.28658H8.5927L10.7847 11.0767H12.2087V5.09766H11.1847V9.6035H11.1367L9.1207 5.09766H7.5127V11.0767H8.5447ZM16.9527 11.0767V10.086H14.5687V8.46627H16.6487V7.52719H14.5687V6.07981H16.8087V5.09766H13.5207V11.0767H16.9527ZM21.0327 7.07058L20.0567 11.0767H18.7447L17.5127 5.09766H18.6087L19.4887 9.74135H19.5367L20.4807 5.71796H21.6967L22.6167 9.74135H22.6647L23.5527 5.09766H24.6327L23.3447 11.0767H22.0247L21.0807 7.07058H21.0327Z",
  fill: "white"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var newTag = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { newTag as default };
